import { MessageSquare, Share2, Heart, MoreHorizontal } from 'lucide-react';
import { Card, CardContent, CardFooter } from '../../components/common/Card';
import { Avatar } from '../../components/common/Avatar';
import { Button } from '../../components/common/Button';
import { Badge } from '../../components/common/Badge';

const mockFeed = [
  {
    id: '1',
    user: 'Sarah Chen',
    avatar: 'https://picsum.photos/seed/sarah/100',
    action: 'published a new app',
    target: 'EcoTracker Pro',
    content: 'Excited to share my latest project with the community! EcoTracker Pro helps you visualize your environmental impact across all your connected services.',
    timestamp: '15m ago',
    likes: 24,
    comments: 5,
    type: 'app_launch',
  },
  {
    id: '2',
    user: 'Marcus Thorne',
    avatar: 'https://picsum.photos/seed/marcus/100',
    action: 'voted on',
    target: 'Proposal #124: Fee Structure',
    content: 'I believe this change is crucial for the long-term sustainability of our developer ecosystem. Let\'s make it happen!',
    timestamp: '1h ago',
    likes: 12,
    comments: 2,
    type: 'governance',
  },
  {
    id: '3',
    user: 'Tech Circle',
    avatar: 'https://picsum.photos/seed/circle/100',
    action: 'started a new discussion',
    target: 'The future of WebAuthn',
    content: 'How are you all finding the new biometric setup? We\'re looking for feedback on the user experience.',
    timestamp: '3h ago',
    likes: 45,
    comments: 18,
    type: 'discussion',
  },
];

export const Feed = () => {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <header>
        <h1 className="text-3xl font-bold text-slate-900">Unified Feed</h1>
        <p className="text-slate-500">Stay updated with everything happening in your ecosystem.</p>
      </header>

      <Card className="border-indigo-100 bg-indigo-50/30">
        <CardContent className="pt-6">
          <div className="flex space-x-4">
            <Avatar fallback="KP" size="md" />
            <div className="flex-1 space-y-4">
              <textarea 
                placeholder="Share something with your circles..."
                className="w-full resize-none border-none bg-transparent p-0 text-lg placeholder:text-slate-400 focus:ring-0"
                rows={2}
              />
              <div className="flex items-center justify-between border-t border-indigo-100 pt-4">
                <div className="flex space-x-2">
                  <Button variant="ghost" size="sm">Image</Button>
                  <Button variant="ghost" size="sm">Poll</Button>
                  <Button variant="ghost" size="sm">App</Button>
                </div>
                <Button size="sm">Post</Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="space-y-6">
        {mockFeed.map((item) => (
          <Card key={item.id}>
            <CardContent className="pt-6">
              <div className="flex items-start justify-between">
                <div className="flex space-x-3">
                  <Avatar src={item.avatar} fallback={item.user} />
                  <div>
                    <div className="flex items-center space-x-2">
                      <span className="font-bold text-slate-900">{item.user}</span>
                      <span className="text-sm text-slate-500">{item.action}</span>
                      <span className="font-semibold text-indigo-600">{item.target}</span>
                    </div>
                    <p className="text-xs text-slate-500">{item.timestamp}</p>
                  </div>
                </div>
                <button className="text-slate-400 hover:text-slate-600">
                  <MoreHorizontal size={20} />
                </button>
              </div>
              
              <div className="mt-4">
                <p className="text-slate-700 leading-relaxed">{item.content}</p>
              </div>

              {item.type === 'app_launch' && (
                <div className="mt-4 rounded-xl border border-slate-100 bg-slate-50 p-4 flex items-center space-x-4">
                  <div className="h-16 w-16 rounded-2xl bg-indigo-600 flex items-center justify-center text-white font-bold text-2xl">
                    E
                  </div>
                  <div className="flex-1">
                    <h4 className="font-bold text-slate-900">EcoTracker Pro</h4>
                    <p className="text-sm text-slate-500">Environmental Analytics</p>
                    <div className="mt-2 flex items-center space-x-2">
                      <Badge variant="secondary">4.9★</Badge>
                      <span className="text-xs text-slate-400">1.2k users</span>
                    </div>
                  </div>
                  <Button size="sm">Install</Button>
                </div>
              )}
            </CardContent>
            <CardFooter className="border-t border-slate-50 py-3">
              <div className="flex w-full items-center justify-between px-2">
                <div className="flex space-x-6">
                  <button className="flex items-center space-x-2 text-slate-500 hover:text-red-500 transition-colors">
                    <Heart size={18} />
                    <span className="text-sm font-medium">{item.likes}</span>
                  </button>
                  <button className="flex items-center space-x-2 text-slate-500 hover:text-indigo-600 transition-colors">
                    <MessageSquare size={18} />
                    <span className="text-sm font-medium">{item.comments}</span>
                  </button>
                  <button className="flex items-center space-x-2 text-slate-500 hover:text-slate-900 transition-colors">
                    <Share2 size={18} />
                  </button>
                </div>
              </div>
            </CardFooter>
          </Card>
        ))}
      </div>
    </div>
  );
};
